import {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";
import ChevronLeftIcon from "../../media/images/ChevronLeftIcon.mjs";
import ChevronRightIcon from "../../media/images/ChevronRightIcon.mjs";
import {Button, Form, Input, InputGroup} from "reactstrap";
import SearchIcon from "../../media/images/SearchIcon.mjs";
import TextLabel from "../../controls/TextLabel/TextLabel.mjs";
import "./SimulationsList.css";
import AppSynthDataIcon from "../../media/app-images/AppSynthDataIcon.mjs";
import AppPerimeterIcon from "../../media/app-images/AppPerimeterIcon.mjs";
import PropTypes from "prop-types";
import AppEditIcon from "../../media/app-images/AppEditIcon.mjs";
import AppSimStatusInfoIcon from "../../media/app-images/AppSimStatusInfoIcon.mjs";
import AppSimStatusSettingsIcon from "../../media/app-images/AppSimStatusSettingsIcon.mjs";
import AppSimStatusReadyIcon from "../../media/app-images/AppSimStatusReadyIcon.mjs";
import AppSimStatusRunningIcon from "../../media/app-images/AppSimStatusRunningIcon.mjs";
import AppSimStatusOverIcon from "../../media/app-images/AppSimStatusOverIcon.mjs";


const prefix = "SimulationsList";

const SimulationsList = class extends Component {
	static propTypes = {
		/**
		 * Defaults to 25 items per page
		 * @type {number}
		 */
		pageSize: PropTypes.number,
		/**
		 * If returned value is true/truish, the perimeters list will be reloaded from server (possibly something changed)
		 * @function
		 * @async
		 * @param {Object} perimeter
		 * @return {Promise<any>}
		 */
		onClick: PropTypes.func,
		/**
		 * Icon on rollover, used in case of onClick function
		 */
		clickIcon: PropTypes.object,
		/** Optional: ID of selected perimeter */
		selected: PropTypes.string,
		/**
		 * Optional: filter function
		 * @function
		 * @param {Array<Object>} perimeters
		 * @return {Array<Object>} Filtered values
		 */
		filter: PropTypes.func,
	}
	constructor(props) {
		super(props);
		this.state = {
			by: Glob.getPageParam('by'),
			page: Number(Glob.getPageParam('page')||1),
			ll: Glob.getLanguageLong(),
			pageSize: props.pageSize || 10,
			clickIcon: this.props.clickIcon || <AppEditIcon/>,
			selected: this.props.selected || null,
			// range: [],
		};
		this.uid = Glob.generateUid(prefix);
		this.fetch = this.fetch.bind(this);
		this.pageNavigation = this.pageNavigation.bind(this);
		this.sort = this.sort.bind(this);
		this.autoSort = this.autoSort.bind(this);
	}
	componentDidMount() {
		Glob.register('currentPage', this.autoSort, this.uid);
		Glob.register('Prefs', () => {
			const ll = Glob.getLanguageLong();
			if (ll !== this.state.ll) this.setState({ll: ll}, this.fetchPerimeters);
		}, this.uid)
		setTimeout( this.fetch );
	}
	componentWillUnmount() {
		Glob.deregister( this.uid );
	}
	async clickAction(s) {
		if (typeof this.props.onClick === 'function' && s && typeof s === "object") {
			const p = structuredClone(s);
			delete p.searchable;
			const toBeReloaded = await this.props.onClick(p);
			if (toBeReloaded) setTimeout(this.fetch);
		}
	}
	fetch() {
		this.setState({loading: true}, async () => {
			const s = ((await appLib.api('simul/list', {}))?.list || []).map( e => {
				e.searchable = [e.id, e.name||'', e.description||'', e.username ]
					.join(' ')
					.toLocaleLowerCase(this.state.ll)
					.replace(/[^a-z0-9-]+/g,' ')
					.trim();
				return e;
			});
			this.setState({ data: s }, this.sort);
		});
	}
	pageNavigation() {
		const maxPages = this.state.pages;
		if (!maxPages || maxPages < 2) return null;
		const cp = parseInt(this.state.page);
		const out = [];
		for (let p = 1; p <= maxPages; p++) out.push(p);
		return (
			<div className="pageNavigation">
				{out.map(p => (
					<div
						key={p}
						className={p === cp ? "current" : "active"}
						onClick={() => Glob.setCurrentPageParam('page', p)}
						title={`${(p - 1) * this.state.pageSize + 1}…${Math.min(p * this.state.pageSize, this.state.totFound)}`}
					>
						{p}
					</div>
				))}
				<span
					onClick={() => Glob.setCurrentPageParam('page', cp - 1)}
					className={cp === 1 ? "current" : "active"}
				>
					<ChevronLeftIcon/>
				</span>
				<span
					onClick={() => Glob.setCurrentPageParam('page', cp + 1)}
					className={cp === maxPages ? "current" : "active"}
				>
					<ChevronRightIcon/>
				</span>
			</div>
		);
	}

	autoSort(cp) {
		if (!cp) cp = Glob.getCurrentPage();
		const ns = {};
		const by = cp.params.by || 'name';
		if (by !== this.state.by) ns.by = by;
		if (parseInt(cp.params.page||'1') !== this.state.page) ns.page = parseInt(cp.params.page||'1');
		if (cp.params.pageSize && parseInt(cp.params.pageSize) !== this.state.pageSize) ns.pageSize = parseInt(cp.params.pageSize);
		if (cp.params.filter !== this.state.filter) ns.filter = cp.params.filter;
		this.setState(ns, this.sort);
	}

	sort() {
		if (!this.state.data) return;
		const by = this.state.by || 'name';
		const currentPage = (() => {
			if (this.state.page && !isNaN(Number(this.state.page))) return parseInt(this.state.page);
			return 1;
		})();
		let page = currentPage;
		let range = structuredClone(this.state.data || []);
		if (this.state.filter) {
			const f = this.state.filter.toLocaleLowerCase(this.state.ll).replace(/[^a-z0-9-]+/g,' ').trim();
			range = range.filter(x => x.searchable.includes(f));
		}
		const totEntries = range.length;
		const pages = Math.ceil(totEntries / this.state.pageSize);
		range.sort((a, b) => a.name.toLocaleLowerCase(this.state.ll).localeCompare(b.name.toLocaleLowerCase(this.state.ll)));
		switch (this.state.by) {
			case 'periName':
				range.sort((a, b) => (a.periName ?? '').toLocaleLowerCase(this.state.ll).localeCompare((b.periName ?? '').toLocaleLowerCase(this.state.ll)));
				break;
			case 'username':
				range.sort((a, b) => (a.username ?? '').toLocaleLowerCase(this.state.ll).localeCompare((b.username ?? '').toLocaleLowerCase(this.state.ll)));
				break;
			case 'creationDate':
				range.sort((a, b) => ( b.creationTime - a.creationTime ));
				break;
			default:
				break;
		}
		if ((page - 1) * this.state.pageSize > range.length) page = 1;
		range = range.slice((page - 1) * this.state.pageSize, page * this.state.pageSize);
		this.setState(
			{
				range: range,
				by: by,
				page: String(page),
				pages: pages,
				totFound: totEntries,
				loading: false,
				clean: false
			},
			() => {
				if (page !== currentPage) Glob.setCurrentPageParam('page', String(page));
			}
		);
	}

	sortBy(axle) {
		if (axle === 'name') axle = undefined;
		if (axle === this.state.by) return;
		if (axle) {
			Glob.setCurrentPageParam('by', axle);
		} else {
			Glob.rmCurrentPageParam('by');
		}
	}

	status2Icon(s) {
		if ( s < 11 ) return <AppSimStatusInfoIcon />;
		if ( s < 40 ) return <AppSimStatusSettingsIcon />;
		if ( s < 50 ) return <AppSimStatusReadyIcon />;
		if ( s < 80 ) return <AppSimStatusRunningIcon />;
		return <AppSimStatusOverIcon />;
	}

	render() {
		if ( ! this.state.range ) return null;
		if ( ! this.state.range.length ) return (<h4><TextLabel value={"No items found"} /></h4>);
		return (
			<div className={prefix} id={this.uid}>
				<Form>
					<InputGroup>
						<Input
							placeholder={ Glob.label('Search') }
							value={ this.state.filter || ''}
							onChange={ e => {
								this.setState({ filter: e.target.value });
							}}
						/>
						<Button
							onClick={ this.fetch }
							color={"primary"}
						>
							<SearchIcon/>
						</Button>
					</InputGroup>
				</Form>
				{ (this.state.range && this.state.range.length > 0) ? (
					<div className={"table-container"}>
						{this.pageNavigation()}
						<table
							className={"data-list" + (typeof this.props.onClick === 'function' ? ' clickable' : '')}
							cellSpacing={0}
							cellPadding={0}
							border={0}
						>
							<thead>
							<tr>
								<th className={"peritype"}><span/></th>
								<th
									role={"button"}
									onClick={() => {
										this.sortBy('name')
									}}
									className={"name " + (this.state.by === 'name' ? 'active' : 'inactive')}
								>
								<span>
									<TextLabel value={"Name"}/>
								</span>
								</th>
								<th
									role={"button"}
									onClick={() => {
										this.sortBy('periName')
									}}
									className={"peri nomobile " + (this.state.by === 'periName' ? 'active' : 'inactive')}
								>
									<span> <TextLabel value={"Perimeter"}/> </span>
								</th>
								<th
									role={"button"}
									onClick={() => {
										this.sortBy('creationDate')
									}}
									className={"desc " + (this.state.by === 'creationDate' ? 'active' : 'inactive')}
								>
									<span> <TextLabel value={"CreationDate"}/> </span>
								</th>
								<th
									role={"button"}
									onClick={() => {
										this.sortBy('username')
									}}
									className={"user " + (this.state.by === 'username' ? 'active' : 'inactive')}
								>
									<span> <TextLabel value={"User"}/> </span>
								</th>
							</tr>
							</thead>
							<tbody>
							{ this.state.range.map( s=>(
								<tr
									className={
										(this.state.selected === s.id ? "selected " : "")
									}
									key={s.id}
									onClick={() => { this.clickAction(s) }}
								>
									<td className={'peritype ' + (s.fake ? 'fake' : 'real')}>
										<div>
											{this.state.clickIcon}
										</div>
										<div>
											{ this.status2Icon(s.status) }
											{s.fake ? <AppSynthDataIcon/> : <AppPerimeterIcon/>}
										</div>
									</td>
									<td className={"name"}>
										<div>
											{s.name ?? s.id}
										</div>
									</td>
									<td className={"peri"}>
										<div>
											{s.periName ?? ''}
										</div>
									</td>
									<td className={"creationDate no-mobile"}>
										<div>
											{new Date(s.creationTime).toLocaleDateString(this.state.ll)}
										</div>
									</td>
									<td className={"user"}>
										<div title={s.username}>
											{ (s.username||'').replace(/@.*/,'') }
										</div>
									</td>
								</tr>
							))}
							</tbody>
						</table>
					</div>
				) : (
					<h4>
						<TextLabel value={"No items found"} />
					</h4>
				)}
			</div>
		)
	}
}

export default SimulationsList;
